export function assertUnreachable(x: never): never {
	throw new Error('Reached unreachable code. Expected never, got: ', x);
}

export function assertUnreachableWithMessage(location: string, x: string): never {
	throw new Error(`Reached unreachable code for ${location}. Got: ${x}`);
}
